const _excluded = ["value", "onChange", "testid", "data-testid"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { MenuItem, TextField } from 'seagull';
import { positiveQuantityInputProps } from "../constants";
export default function DiscountTextField(props) {
  const {
    value,
    onChange: _onChange,
    testid,
    ['data-testid']: dtestid
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const isPercentDiscount = value.type === 'percent';
  const tid = dtestid || testid;
  return /*#__PURE__*/React.createElement(TextField, _extends({
    disableSuffixPadding: true,
    isPercentage: isPercentDiscount,
    isMoney: !isPercentDiscount,
    inputProps: positiveQuantityInputProps,
    value: value.amount,
    "data-testid": tid && tid + '-amount',
    onChange: e => {
      const amount = e.target.value;

      _onChange({
        amount,
        type: value.type
      });
    },
    suffix: /*#__PURE__*/React.createElement(TextField, {
      select: true,
      preventOutline: true,
      width: 60,
      minWidth: 60,
      size: props.size,
      disabled: props.disabled,
      SelectProps: {
        autoWidth: true
      },
      value: value.type,
      "data-testid": tid && tid + '-type',
      onChange: e => {
        const type = e.target.value;

        _onChange({
          type,
          amount: value.amount
        });
      },
      onBlur: rest.onBlur
    }, [{
      value: 'percent',
      text: '%'
    }, {
      value: 'value',
      text: '$'
    }].map(_ref => {
      let {
        value,
        text
      } = _ref;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: value,
        value: value,
        "data-testid": tid && "".concat(tid, "-option-").concat(value)
      }, text);
    }))
  }, rest));
}